export const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS';
export const USER_LOGOUT_REQUEST = 'USER_LOGOUT_REQUEST';
export const SET_LANGUAGE_CODE = 'SET_LANGUAGE_CODE';
export const UPDATE_USER_GROUPS = 'UPDATE_USER_GROUPS';
export const UPDATE_ACCOUNT_USER = 'UPDATE_ACCOUNT_USER';
